export default __webpack_public_path__ + "static/media/icon-plus-button-green.fd42ef19.svg";